<!-- 添付ファイル表示用コンポーネント -->
<template>
    <div>
        <div @click="close" class="full-image-wrap child-img-center">
            <!-- 画像 -->
            <img class="target-img mx-3" :src="currentImageUrl" v-show="currentImageUrl!=null && !isPdfPath">
            <!-- pdf -->
            <img @click.stop="open(currentImageUrl)" class="pdf-img mx-3" src="../img/PdfIcon.png" v-show="currentImageUrl!=null && isPdfPath">
            <!-- 画像 -->
            <img class="target-img mx-3" :src="currentImageUrlSecond" v-show="currentImageUrlSecond!=null && !isPdfPath2">
            <!-- pdf -->
            <img @click.stop="open(currentImageUrlSecond)" class="pdf-img mx-3" src="../img/PdfIcon.png" v-show="currentImageUrlSecond!=null && isPdfPath2">
            <!-- 画像 -->
            <img class="target-img mx-3" :src="currentImageUrlThird" v-show="currentImageUrlThird!=null && !isPdfPath3">
            <!-- pdf -->
            <img @click.stop="open(currentImageUrlThird)" class="pdf-img mx-3" src="../img/PdfIcon.png" v-show="currentImageUrlThird!=null && isPdfPath3">
            <button
                    type="button"
                    @click="close"
                    class="close"
                >閉じる</button>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            currentImageUrl:String,
            currentImageUrlSecond:String,
            currentImageUrlThird:String,
        },
        data: function () {
            return {
                pdf:"^.pdf$",
                isPdfPath:null,
                isPdfPath2:null,
                isPdfPath3:null,
            }
        },
        methods: {
            /**
             * ポップアップを閉じる時の処理
             */
            close: function () {
                //console.log("close");
                this.$emit('close-button');
            },
            /**
             * ファイルパスに文字列「.pdf」が含まれているか判定
             */
            checkPdf(currentImageUrl){
                var reg = new RegExp(/.pdf/);
                const respons = reg.test(currentImageUrl);
                return respons;
            },
            open(url) {
                window.open(url, '_blank')
            }
        },
        mounted() {
            this.$data.isPdfPath = this.checkPdf(this.$props.currentImageUrl);
            this.$data.isPdfPath2 = this.checkPdf(this.$props.currentImageUrlSecond);
            this.$data.isPdfPath3 = this.checkPdf(this.$props.currentImageUrlThird);
        }
    }
</script>
<style lang="scss">
    .full-image{
        width: 600px;
        height:auto;
        display: block;

        position:fixed;
        top:100px;
        left:50%;
        transform:translate(-50%);
        z-index:999;
    }
    .full-image-wrap{
        background-color:rgba(0,0,0,.8);
        width: 100%;
        height: 100%;
        position:fixed;
        top:0;
        z-index:999;
    }
    .target-img{
        border: 1px solid #fff;
        width: 320px;
        height:auto;
    }
    .pdf-img{
        width: 300px;
        height:auto;
        cursor: pointer;
        cursor: hand;
    }

    /* 画像関連
       ポップアップ画像上下左右中央寄せ(imgの親要素に設定する) */
    .child-img-center{
        display: -webkit-flex; /* Safari用 */
        display: flex;
        -webkit-justify-content: center; /* Safari用 */
        justify-content: center;
        -webkit-align-items: center; /* Safari用 */
        align-items: center;
    }

    .close{
        position:fixed;
        top:30px;
        right:50px;
        font-size: 16px;
        padding: 20px;
    }
</style>

